import { render, staticRenderFns } from "./cly-in-page-notification.vue?vue&type=template&id=33c99a72"
import script from "./cly-in-page-notification.vue?vue&type=script&lang=js"
export * from "./cly-in-page-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports